
export enum ReportType {
  DATE_RANGE = 1,
  CARDEX = 2
}
